export default __webpack_public_path__ + "static/media/aptos-disable.790e3886.svg";